import React from "react";

function InformationManagement() {
    return <div>InformationManagement</div>;
}

export default InformationManagement;
